import * as yup from 'yup'
import { PHONE_NUMBER_REGEX } from '@/shared/config/constants'

export const UpdateProfileSchema = yup.object().shape({
    firstName: yup.string().min(2, 'First Name must be at least 2 characters').max(50),
    lastName: yup.string().min(2, 'Last Name must be at least 2 characters').max(50),
    branch: yup
        .object({
            value: yup.string(),
            label: yup.string()
        })
        .required('Branch is required'),
    phoneNumber: yup
        .string()
        .matches(PHONE_NUMBER_REGEX, 'Phone number is not valid')
        .required('Phone Number is required'),
    relationship: yup.string().required('Relationship is required'),
    address: yup.string().max(70),
    city: yup.string().max(50),
    state: yup.string().max(50),
    country: yup.object({
        value: yup.string(),
        label: yup.string()
    })
})
